<div class="flex flex-col">
  @for (lagerplatzInhalt of lagerplatzInhalte(); track lagerplatzInhalt.lagerplatz.id) {
    @let isDifArtikel = lagerplatzInhalt.inhalt[0].artikel.kzartikelart === 'DIF' || lagerplatzInhalt.inhalt[0].artikel.kzartikelart === 'SDIF';

    <div class="flex flex-row justify-between flex-nowrap cursor-pointer hover:bg-hover p-4 gap-2"
         (click)="resolve(lagerplatzInhalt.lagerplatz)">
      <div class="flex flex-col w-full">
        <span class="text-lg font-semibold">{{lagerplatzInhalt.lagerplatz.lagerplatz}}</span>

        @if (isDifArtikel) {
          <span class="text-sm text-light">{{ lagerplatzInhalt.inhalt[0].einheit.arteh }}</span>
        }
      </div>
      <soft-stock-amount
        [hideUnit]="isDifArtikel"
        [stockAmount]="lagerplatzInhalt.inhalt[0]" class="flex grow shrink-0" />
      <div class="flex flex-col justify-center items-center">
        <i class="fa-regular fa-chevron-right color-light"></i>
      </div>
    </div>
  }
</div>
